/** Shared helpers for mapping /enquiry/create_new_enquiry field_errors onto dynamic form fields. */

export function getFormFieldId(field) {
  if (!field || typeof field !== "object") return "";
  return String(field.name ?? field.field ?? field.key ?? field.id ?? "").trim();
}

export function mapApiFieldErrors(raw, fields) {
  const ids = new Set(fields.map(getFormFieldId).filter(Boolean));
  const out = {};
  for (const [apiKey, message] of Object.entries(raw || {})) {
    let key = apiKey;
    if (!ids.has(key)) {
      if (apiKey === "mobile" && ids.has("phone")) key = "phone";
      else if (apiKey === "address_line" && ids.has("address")) key = "address";
    }
    if (ids.has(key)) out[key] = message;
  }
  return out;
}
